import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Colors, CommonFonts } from '@/theme';

const useStyles = makeStyles((theme) =>
  createStyles({
    radioFormControl: {
      margin: theme.spacing(0, 5),
    },
    radioFormControlLabel: {
      ...CommonFonts.darkFont16,
    },
    title: {
      ...CommonFonts.darkFont14,
      fontWeight: 600,
    },
    collectionTypeGroup: {
      width: '100%',
    },
  })
);

export default useStyles;
